/**
 * Adds alpha (opacity) to a hex color string.
 * @param hex - Hex color string in the format #RRGGBB or #RRGGBBAA
 * @param alpha - Alpha value between 0 (transparent) and 1 (opaque)
 * @returns Hex color string with alpha channel
 */
export function applyAlphaToHex(hex: string, alpha: number): string {
  if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) return hex;
  const base = hex.slice(0, 7);
  const a = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, "0");
  return base + a;
}
